import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../Elements/Modal/Modal";
import SecondButton from "../../Elements/SecondButton/SecondButton";
import { fetchCountriesByRegion } from "../../../services/PackagesService";
import "./RegionCountriesModal.css";

const RegionCountriesModal = ({ isOpen, onClose, regionId, regionName }) => {
  const { t, i18n } = useTranslation();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const language = i18n.resolvedLanguage || "en";

  useEffect(() => {
    if (!isOpen || !regionId) return;

    const load = async () => {
      try {
        setLoading(true);
        setError("");
        const data = await fetchCountriesByRegion({
          regionId,
          currency: "EUR",
          language: language,
        });
        setCountries(data.items || []);
      } catch (e) {
        setError(t("common.error"));
        setCountries([]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [isOpen, regionId, t]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${t("offers.viewCoveredCountries") || "Covered countries"} (${regionName})`}
      actions={<SecondButton onClick={onClose}>{t("common.close")}</SecondButton>}
    >
      <div className="region-countries-modal-body">
        {loading && <p className="text-muted">{t("common.loading")}</p>}
        {error && <p className="text-muted">{error}</p>}

        {!loading && !error && countries.length === 0 && (
          <p className="text-muted">{t("offers.noPackages")}</p>
        )}

        {!loading && !error && countries.length > 0 && (
          <ul className="region-countries-list">
            {countries.map((c) => {
              const code = c.id ? String(c.id).toLowerCase() : "";
              const flagSrc = code ? `/icons/flags/${code}.png` : null;

              return (
                <li key={c.id} className="region-country-item">
                  <div className="region-country-left">
                    {flagSrc && <img src={flagSrc} alt={c.name} className="region-country-flag" />}
                    <span className="region-country-name">{c.name}</span>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </Modal>
  );
};

export default RegionCountriesModal;
